var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "currentColor",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 26.25q-.687 0-1.185-.498a1.62 1.62 0 0 1-.498-1.185V3.433q0-.687.498-1.185a1.62 1.62 0 0 1 1.184-.498h11.802q.686 0 1.184.498t.498 1.185v21.134q0 .687-.498 1.185a1.62 1.62 0 0 1-1.184.498zm-.36-4.453v2.77q0 .135.112.247a.34.34 0 0 0 .247.112h11.802q.135 0 .246-.112a.34.34 0 0 0 .112-.247v-2.77zm6.265 2.377q.341 0 .577-.235a.8.8 0 0 0 .237-.583q0-.346-.242-.582a.8.8 0 0 0-.582-.237q-.341 0-.577.242a.8.8 0 0 0-.237.582q0 .351.242.582a.81.81 0 0 0 .582.231M7.74 20.473h12.52V5.643H7.74zm0-16.154h12.52v-.886a.34.34 0 0 0-.113-.247.34.34 0 0 0-.246-.112H8.099a.34.34 0 0 0-.247.112.34.34 0 0 0-.112.247z"
  })));
};
export default SvgMobile;